module.exports = __webpack_public_path__ + "img/slide-25.981f3053.jpg";